import { styled } from "@mui/material";
import { StyledCard } from "../styledCard.styled";

export const StyledContactCard = styled(StyledCard)(({ theme }) => ({
  width: "100%",
  gridArea: "2 / 1 / 8 / 2",
  overflowY: "auto",
  ".content": {
    paddingInline: "2rem",
    gap: ".25rem",
    display: "flex",
    flexDirection: "column",
    ".row": {
      display: "flex",
      width: "100%",
      minHeight: "1.5rem",
      alignItems: "center",
      ".contactInfo": {
        minWidth: "5rem",
      },
      h4: {
        color: theme.contrast.dark,
        fontWeight: "600",
        width: "60%",
      },
      ".end": {
        textAlign: "end"
      }
    },
  },
  ".head": {
    background: theme.color.main,
    display: "flex",
    marginBottom: ".5rem",
    alignItems: "center",
    color: theme.color.background,
    padding: ".5rem 2rem",
    justifyContent: "space-between",
    h3: {
      fontWeight: "bold",
    },
    ".editBtn": {
      cursor: "pointer",
      "&:hover": {
        color: theme.color.dark,
      },
    },
  },
  "& .MuiOutlinedInput-root": {
    border: `2px solid ${theme.color.dark}`,
    width: "100%",
    padding: "0",
    input: {
      paddingBlock: ".25rem !important",
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
    paddingBottom: "0",

    ".content": {
      paddingInline: "1rem",
      gap: ".10rem",
      justifyContent: "center",
      height: "100%",
      ".row": {
        gap: ".5rem",
        minHeight: "0",
        justifyContent: "space-between",
        h4: {
          width: "fit-content",
        },
      },
    },
    ".head": {
      marginBottom: "0",
      padding: ".25rem 1rem",
      h3: {
        fontSize: "1.2rem",
      },
      svg: {
        width: "24px"
      },
    },
  },
}));
